import { HOME_ROUTE, WORK_TGS_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { LayoutPages } from "../layoutPages";
import { WorkTgsWidget } from "../../widgets/workTgs";
import { FEATURES, FEATURE_SECTIONS, hasFeature } from "../../entities/my";
import { AccessDeniedRedirect } from "../../shared/ui/accessDeniedRedirect";

export default function WorkTgsPage() {
    const {my} = useAppSelector(s => s.myReducer)
    const isAccess = hasFeature(my, FEATURE_SECTIONS.WORK_TGS)
        && hasFeature(my, FEATURES.WORK_TGS.LIST)

    if(!isAccess){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    return (
        <LayoutPages title={WORK_TGS_ROUTE.name}>
            <WorkTgsWidget />
        </LayoutPages>
    )
}
